import { Component, ElementRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Title } from '@angular/platform-browser';
import { ThemeService } from '../../../theme.service';

@Component({
    selector: 'app-videos',
    imports: [CommonModule],
    templateUrl: './videos.component.html',
    styleUrl: './videos.component.scss'
})
export class VideosComponent {

  constructor(private titleService: Title, private themeService: ThemeService

  ) {
    this.themeService.setTitle("Videos");
    this.titleService.setTitle("Videos Tutoriales")
  }

  ngOnInit() {
    this.actualVideo = this.videos[0];
  }

  @ViewChild("videoPlayer", { static: false }) videoplayer!: ElementRef;
  videos: any[] = [{
    id: 1,
    title: "Alta de conductores",
    src: "ALTA_CONDUCTORES.mp4",
    thumbnail: "thumbnails/mesa_trabajo.jpg"
  },
    {
      id:2,
      title:"Generar QR desde APP",
      src:"src/assets/videos/medios/XIGA_QR_CONDUCTOR_APP_2.mp4",
      thumbnail:"thumbnails/mesa_trabajo2.jpg"
    },
    {
      id:3,
      title:"Visualizar QR(conductor)",
      src:"src/assets/videos/medios/XIGA_QR_CONDUCTOR_APP_3.mp4",
      thumbnail:"thumbnails/mesa_trabajo3.jpg"
    },
    /*{
      id:4,
      title:"Consulta tickets con firma",
      src:"consulta_tickets_firma.mp4",
      thumbnail:"thumbnails/mesa_trabajo4.jpg"
    }*/
  ];
  actualVideo: any;


  selectVideo(video: any) {
    this.videoplayer.nativeElement.load();
    this.actualVideo = video;
  }
}
